import { QUERY_VIEWMODEL_REQUEST, QUERY_VIEWMODEL_SUCCESS, QUERY_VIEWMODEL_FAILURE, DROP_VIEWMODEL_STATE, CONNECT_VIEWMODEL, DISCONNECT_VIEWMODEL, VIEWMODEL_STATE_UPDATE, VIEWMODEL_EVENT_RECEIVED } from '../internal/action-types';
export var queryViewModelRequest = function queryViewModelRequest(query, selectorId) {
  return {
    type: QUERY_VIEWMODEL_REQUEST,
    query: query,
    selectorId: selectorId
  };
};
export var queryViewModelSuccess = function queryViewModelSuccess(query, result, selectorId) {
  return {
    type: QUERY_VIEWMODEL_SUCCESS,
    query: query,
    result: result,
    selectorId: selectorId
  };
};
export var queryViewModelFailure = function queryViewModelFailure(query, error, selectorId) {
  return {
    type: QUERY_VIEWMODEL_FAILURE,
    query: query,
    error: error,
    selectorId: selectorId
  };
};
export var viewModelStateUpdate = function viewModelStateUpdate(query, state, initial, selectorId) {
  return {
    type: VIEWMODEL_STATE_UPDATE,
    query: query,
    state: state,
    initial: initial,
    selectorId: selectorId
  };
};
export var viewModelEventReceived = function viewModelEventReceived(query, event, selectorId) {
  return {
    type: VIEWMODEL_EVENT_RECEIVED,
    query: query,
    event: event,
    selectorId: selectorId
  };
};
export var dropViewModelState = function dropViewModelState(query, selectorId) {
  return {
    type: DROP_VIEWMODEL_STATE,
    query: query,
    selectorId: selectorId
  };
};
export var connectViewModel = function connectViewModel(query, selectorId) {
  return {
    type: CONNECT_VIEWMODEL,
    query: query,
    selectorId: selectorId
  };
};
export var disconnectViewModel = function disconnectViewModel(query, selectorId) {
  return {
    type: DISCONNECT_VIEWMODEL,
    query: query,
    selectorId: selectorId
  };
};
//# sourceMappingURL=actions.js.map